import React, { useMemo } from 'react';

import Link from '@swf/components/Link/Link';

import type {
  DynamicBannerTemplate,
  ImageFetchProps,
  MarketDynamicBanner
} from '../../../model/types';
import BannerImage from '../../BannerImage/BannerImage';

import styles from './MarketBanner.scss';
import EventName from './components/EventName';
import OddsBoostDynamicBannerContent from './templates/Oddsboost';
import RequestABetDynamicBannerContent from './templates/RequestABet';
import StandardMarketDynamicBannerContent from './templates/Standard';

type MarketDynamicBannerTemplate = Extract<
  DynamicBannerTemplate,
  'STANDARD' | 'ODDS_BOOST' | 'REQUEST_A_BET'
>;

const bannerComponents: Record<MarketDynamicBannerTemplate, React.FC<MarketDynamicBanner>> = {
  ODDS_BOOST: OddsBoostDynamicBannerContent,
  REQUEST_A_BET: RequestABetDynamicBannerContent,
  STANDARD: StandardMarketDynamicBannerContent
};

const MarketBanner: React.FC<MarketDynamicBanner & ImageFetchProps> = (props) => {
  const {
    image,
    template,
    eventType,
    competition,
    event,
    market: { marketLevels },
    priority
  } = props;
  const BannerContentComponent = useMemo(
    () => (template !== 'BET_BUILDER' ? bannerComponents[template] : null),
    [template]
  );

  if (!BannerContentComponent) return null;

  return (
    <div className={styles.container}>
      <BannerImage image={image} priority={priority} />
      <div className={styles.inner}>
        <Link
          alias={
            marketLevels && marketLevels[0] === 'AVB_EVENT'
              ? 'sportsEvent'
              : 'sportsCompetitionOutrights'
          }
          values={{ ...eventType, ...competition, ...event }}
          className={styles.link}
        >
          <EventName eventName={event.eventName} />
        </Link>
        <BannerContentComponent {...props} />
      </div>
    </div>
  );
};

export default MarketBanner;
